const pageName = { singular: 'Working Space', plural: 'Working Space' }

export default [
  {
    path: '/work-spaces',
    name: 'work-spaces',
    component: () => import('@/views/pages/master-data/working-space/Table.vue'),
    meta: {
      name: pageName,
      routeCreate: 'work-spaces-create',
      routeEdit: 'work-spaces-edit',
      resource: 'MasterData',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/work-spaces/create',
    name: 'work-spaces-create',
    component: () => import('@/views/pages/master-data/working-space/Form.vue'),
    meta: {
      name: pageName,
      navActiveLink: 'work-spaces',
      resource: 'MasterData',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: pageName.plural,
          route: 'work-spaces',
        },
        {
          text: 'Create',
          active: true,
        },
      ],
    },
  },
  {
    path: '/work-spaces/:id/edit',
    name: 'work-spaces-edit',
    component: () => import('@/views/pages/master-data/working-space/Form.vue'),
    meta: {
      name: pageName,
      navActiveLink: 'work-spaces',
      resource: 'MasterData',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: pageName.plural,
          route: 'work-spaces',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
